// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type ReactNode } from 'react';
// eslint-disable-next-line jira/restricted/prop-types
import PropTypes from 'prop-types';
import { styled } from '@compiled/react';
import flatten from 'lodash/flatten';
import { token } from '@atlaskit/tokens';

/**
 * This form has a classname "ajs-dirty-warning-exempt" this will prevent filled input fields
 * causing confirmation dialog when you want to navigate away. This functionality is coming from
 * JIRA monolith.
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.form({
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	margin: `0 0 ${token('space.300', '24px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FormItemWrapper = styled.span({
	marginRight: token('space.100', '8px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:last-child': {
		marginRight: 0,
	},
});

type Props = {
	children: ReactNode;
};

// eslint-disable-next-line jira/react/no-class-components
export default class HeaderFormContainer extends PureComponent<Props> {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
	};

	static defaultProps = {
		children: null,
	};

	render() {
		const { children } = this.props;
		const childrenArr = Array.isArray(children) ? children : [children];

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<Wrapper className="ajs-dirty-warning-exempt">
				{flatten(childrenArr).map((child, idx) => (
					<FormItemWrapper key={idx}>{child}</FormItemWrapper>
				))}
			</Wrapper>
		);
	}
}
